const domain = window.location.host;
const isLocal = domain === 'localhost:3000';
const protocol = isLocal ? 'http' : 'https';

// Always use window.cdConfig for configuration values
// The config.js file is generated for both local development and production

// Check if cdConfig exists and has all required properties
if (
  !window['cdConfig'] ||
  !window['cdConfig'].region ||
  !window['cdConfig'].userPoolId ||
  !window['cdConfig'].userPoolWebClientId ||
  !window['cdConfig'].cognitoDomain
) {
  console.error('Missing required configuration. Please ensure cdConfig is properly initialized.');
  throw new Error('Missing required configuration in cdConfig');
}

const config = {
  region: window['cdConfig'].region,
  identityPoolRegion: window['cdConfig'].region,
  userPoolId: window['cdConfig'].userPoolId,
  userPoolWebClientId: window['cdConfig'].userPoolWebClientId,
  mandatorySignIn: false,
  oauth: {
    domain: window['cdConfig'].cognitoDomain,
    scope: ['email', 'openid', 'profile'],
    redirectSignIn: `${protocol}://${domain}`,
    redirectSignOut: `${protocol}://${domain}`,
    responseType: 'code',
  },
};

export { config };
